import React from 'react';
import ReportingSalesMembershipsPage from '../components/ReportingSalesMembershipsPage';

const ReportingSalesMembershipsApp = (props) => (
  <ReportingSalesMembershipsPage {...props} />
);

export default ReportingSalesMembershipsApp;
